<mat-expansion-panel class="mat-elevation-z0">
  <mat-expansion-panel-header>
    <mat-panel-title
      [class.isDifferent]="isNameDifferent()">{{comboGroupName}}</mat-panel-title>
    <mat-panel-description>combo products: {{ comboGroupStructure.products.length }}</mat-panel-description>
  </mat-expansion-panel-header>
  <section *ngIf="isEditingMode">
    <header class="header">
      <div class="col" style="flex: 3">Name</div>
    </header>
    <div>
      <div class="row">
        <div class="col" style="flex: 3">
          <input [(ngModel)]="applyNameChangeToAll"
                 type="checkbox"
                 [disabled]="!allowOverrides"
                 (blur)="onChangeInformationMessage()">
          <mat-label>{{ 'MENU.APPLY_NAMES_TO_ALL' | translate }}</mat-label>
          <br>
          <input [(ngModel)]="comboGroupName"
                 class="modifier-input input-name"
                 [class.isDifferent]="isNameDifferent()"
                 type="text"
                 [readonly]="!allowOverrides"
                 (blur)="onChangeInformationMessage()">
          <mat-icon *ngIf="isNameDifferent() && allowOverrides" matSuffix mat-icon-button aria-label="Clear"
                    matTooltip="{{originalComboGroup.name ?? 'undefined'}}" (click)="clearName()"
                    class="restore">
            restore
          </mat-icon>
          <div *ngFor="let lang of nameTranslationKeys">
            <mat-label [class.isDifferent]="isNameTranslationDifferent(lang)">
              {{lang}}
            </mat-label>
            <mat-icon *ngIf="isNameTranslationDifferent(lang) && allowOverrides" matSuffix mat-icon-button aria-label="Clear"
                      matTooltip="{{originalComboGroup.nameTranslations[lang] ?? 'undefined'}}" (click)="clearNameTranslation(lang)"
                      class="restore">
              restore
            </mat-icon>
            <br>
            <input value = "{{nameTranslations[lang]}}" (input) = "changeComboGroupNameTranslations($event, lang)"
                   [readonly]="!allowOverrides"
                   class="modifier-input input-name">
          </div>
        </div>
      </div>
    </div>
  </section>
  <mat-icon *ngIf="!isSavingMode && allowOverrides"
    (click)="editMode()"
    class="edit-icon"
    color=""
    matTooltip="{{ iconTooltip }}"
    matTooltipPosition="above">{{ isEditingMode ? 'save' : 'edit' }}
  </mat-icon>
  <mat-spinner *ngIf="isSavingMode" [diameter]="40"></mat-spinner>
  <mat-icon
    (click)="showModifiers()"
    class="edit-icon"
    color=""
    matTooltip="{{ 'MENU.MODIFIERS' | translate }}"
    matTooltipPosition="above">view_module
  </mat-icon>
  <section>
    <header class="header">
      <div class="col"></div>
      <div class="col" style="flex: 3">Name</div>
      <div class="col">Price</div>
      <div class="col"></div>
    </header>

    <app-edit-combo-product *ngFor="let comboProductStructure of comboProductStructures; trackBy: trackByFn; let i = index;"
                            [isEditingGroupMode] = "isEditingMode"
                            [currency]="currency"
                            [initialComboProduct]="getInitialComboProduct(comboProductStructure.externalProductId, comboProductStructure.sizeId)"
                            [comboProductStructure]="comboProductStructure"
                            [originalComboProductStructure]="getOriginalComboProduct(comboProductStructure.externalProductId, comboProductStructure.sizeId)"
                            [dictionaryProducts]="dictionaryProducts"
                            [dictionarySizes]="dictionarySizes"
                            [originalDictionaryProducts]="originalDictionaryProducts"
                            [overridePositionsMap]="overridePositionsMap"
                            [menuSections]="menuSections"
                            [menuSectionId]="menuSectionId"
                            [currentOrganization]="currentOrganization"
                            [productId]="productId"
                            [saveForMenuSections]="saveForMenuSections"
                            [externalComboGroupId] = "this.comboGroup.externalId"
                            [saveForAllCombo]="saveForAllCombo"
                            [saveForAllProductsInComboGroup]="saveForAllProductsInComboGroup"
                            [comboGroupStructure]="comboGroupStructure"
                            (changeInformationMessageEvent)="changeInformationMessageEvent.emit($event)"
                            [allowOverrides]="allowOverrides"
    ></app-edit-combo-product>
  </section>

</mat-expansion-panel>
